import { render, staticRenderFns } from "./EditableTextElement.vue?vue&type=template&id=197f4df2&scoped=true"
import script from "./EditableTextElement.vue?vue&type=script&lang=js"
export * from "./EditableTextElement.vue?vue&type=script&lang=js"
import style0 from "./EditableTextElement.vue?vue&type=style&index=0&id=197f4df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f4df2",
  null
  
)

export default component.exports